import { bunja } from 'bunja';
import { atom } from 'jotai';

import { marketsBunja } from './market';
import { pswapDetailsBunja } from './pswap-detail';
import { pswapTickersBunja } from './pswap-ticker';

export type TradeSymbol = string | null;

export const tradeSymbolAtom = atom<TradeSymbol>(null);
tradeSymbolAtom.debugLabel = 'tradeSymbolAtom';

export const tradeSymbolBunja = bunja(() => {
  const { pswapTickersAtom } = bunja.use(pswapTickersBunja);
  const { marketsAtom } = bunja.use(marketsBunja);
  const { pswapDetailsAtom } = bunja.use(pswapDetailsBunja);
  const getTradeTickerAtom = atom((get) => {
    const currentSymbol = get(tradeSymbolAtom);
    const tickers = get(pswapTickersAtom);
    if (!currentSymbol || !tickers) return undefined;
    return tickers[currentSymbol];
  });

  const getTradeSymbolAtom = atom((get) => {
    const currentSymbol = get(tradeSymbolAtom);
    const markets = get(marketsAtom);
    if (!currentSymbol || !markets) return undefined;
    return markets[currentSymbol];
  });

  const getTradeSymbolDetailAtom = atom((get) => {
    const currentSymbol = get(tradeSymbolAtom);
    const pswapDetails = get(pswapDetailsAtom);
    if (!currentSymbol || !pswapDetails) return undefined;
    return pswapDetails[currentSymbol];
  });

  return { tradeSymbolAtom, getTradeTickerAtom, getTradeSymbolAtom, getTradeSymbolDetailAtom };
});
tradeSymbolBunja.debugLabel = 'tradeSymbolBunja';
